import { render, staticRenderFns } from "./OrDivider.vue?vue&type=template&id=5c6a2202&scoped=true"
import script from "./OrDivider.vue?vue&type=script&lang=js"
export * from "./OrDivider.vue?vue&type=script&lang=js"
import style0 from "./OrDivider.vue?vue&type=style&index=0&id=5c6a2202&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6a2202",
  null
  
)

export default component.exports